import _objectSpread from "/nerv.app/node_modules/@babel/runtime/helpers/esm/objectSpread2.js";
import { createVNode as _createVNode } from "vue";
import { toRaw } from 'vue';
import Canvas from '@antv/f2-vue';
import { Chart, Axis, Point } from '@antv/f2';
import moment from "moment";
export default {
  name: 'point-chart',
  //散点图
  data: function data() {
    return {};
  },
  props: {
    list: {
      type: Array,
      default: []
    },
    xConfig: {
      type: Object,
      default: {}
    },
    yConfig: {
      type: Object,
      default: {}
    },
    startTime: {},
    endTime: {}
  },
  computed: {
    chartData: function chartData() {
      return this.formatData(this.list);
    },
    hasData: function hasData() {
      return !!this.list.length;
    }
  },
  methods: {
    formatData: function formatData(arr) {
      if (!arr || !arr.length) return [{
        x: this.startTime,
        y: 300
      }];
      var result = arr;
      return result;
    },
    getColor: function getColor() {
      var self = this;
      return {
        field: 'y',
        callback: function callback(y) {
          if (!self.hasData) return 'transparent';
          if (y > 520) return '#FF5B18';
          if (y < 260) return '#3F96F3';
          return '#A8A8A8';
        }
      };
    }
  },
  render: function render() {
    var _this = this;

    var chartData = this.chartData,
        xConfig = this.xConfig,
        yConfig = this.yConfig;
    if (!chartData.length) return null;
    var gridColor = window.theme === "dark" ? "#595959" : "#e2e2e4";
    console.log('startTime', this.startTime);
    console.log('endTime', this.endTime);
    console.log('chartData', chartData);
    return _createVNode("div", {
      "className": "chart-container"
    }, [_createVNode(Canvas, {
      "pixelRatio": window.devicePixelRatio
    }, {
      default: function _default() {
        return [_createVNode(Chart, {
          "data": toRaw(chartData),
          "scale": {
            x: _objectSpread({
              type: 'time',
              range: [0, 1],
              formatter: function formatter(v) {
                return moment(v).format('HH:mm');
              },
              ticks: [_this.startTime, _this.endTime]
            }, xConfig),
            y: _objectSpread({
              ticks: [0, 260, 520, 780]
            }, yConfig)
          }
        }, {
          default: function _default() {
            return [_createVNode(Axis, {
              "field": "x",
              "style": {
                label: {
                  align: 'between'
                },
                line: {
                  opacity: 0
                },
                grid: {
                  opacity: 0
                }
              }
            }, null), _createVNode(Axis, {
              "field": "y",
              "position": "right",
              "style": {
                line: {
                  opacity: 0
                },
                grid: {
                  lineDash: [0, 0],
                  stroke: gridColor,
                  lineWidth: "0.5"
                }
              }
            }, null), _createVNode(Point, {
              "x": "x",
              "y": "y",
              "color": _this.getColor()
            }, null)];
          }
        })];
      }
    })]);
  }
};